import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../style/PlaceOrder.css";
import "../../../style/customresponsivefile.css";
import { ToothData } from "../../../Interfaces/ToothData";
import { Dropdown } from "react-bootstrap";
import { OrderDraft } from "../interface/IPatientDetails";
import { ExistingFile } from "../../ModelViewer";
import { ROUTES } from "../../../Routes/routes";
import { apiAxios } from "../../../utils/apiAxios";
import { formatSlotDate, formatSlotTime } from "../../../utils/slotBooking";
interface PlaceOrderProps {
  scanFiles: (File | ExistingFile)[];
  orderDraft: OrderDraft | null;
  onHandleBack?: () => void;
  DraftId?: string | undefined;
  isDesignService?: boolean;
  isSlotBooking?: boolean;
  slotDate?: string;
  slotTime?: string;
  attachmentFiles: File[];
  notes: string;
}


interface OrderPackage {
  orderTypeId: number;
  orderTypeName?: string;
  teeth: ToothData[];
  caseID?: number;
}

interface Coupon {
  couponID: number;
  couponCode: string;
  amount: number;
  percentage: number;
}

interface DeliveryType {
  orderTypeID: number;
  orderTypeName: string;
  turnaroundTimeValue: number;
  turnaroundTimeUnit: number;
  acceptanceTiming: string;
  maximumCapacity: string;
  isActive: boolean;
}
const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY as string;

const PlaceOrder: React.FC<PlaceOrderProps> = ({ scanFiles, orderDraft, onHandleBack, DraftId, notes, isDesignService = false, attachmentFiles, isSlotBooking = false, slotDate = "", slotTime = "" }) => {
  const [payment, setPayment] = useState < "razorpay" | "wallet" | "upi" > ("razorpay");
  const [selectedTeeth, setSelectedTeeth] = useState < ToothData[] > ([]);
  const [isPlacingOrder, setIsPlacingOrder] = useState(false);
  const [isDetailUploaded, setIsDetailUploaded] = useState(false);
  const [deliveryTypes, setDeliveryTypes] = useState < DeliveryType[] > ([]);
  const [selectedDelivery, setSelectedDelivery] = useState < DeliveryType | null > (null);
  const [patientId, setPatientId] = useState < number | null > (null);
  const [orderPackages, setOrderPackages] = useState < OrderPackage[] > ([]);
  const [unavailableOrders, setUnavailableOrders] = useState < any[] > ([]);
  const [clubAllPackages, setClubAllPackages] = useState(false);
  const [coupons, setCoupons] = useState < Coupon[] > ([]);
  const [showDeliveryPopup, setShowDeliveryPopup] = useState(false);
  const [availableDeliveryTypes, setAvailableDeliveryTypes] = useState < DeliveryType[] > ([]);
  const [pendingOrder, setPendingOrder] = useState(false);

  const [selectedPopupDelivery, setSelectedPopupDelivery] = useState < {
    [caseID: number]: number;
  } > ({});

  const [isUpdatingDelivery, setIsUpdatingDelivery] = useState(false);

  const [appliedCoupon, setAppliedCoupon] = useState < Coupon | null > (null);
  const realFiles = scanFiles.filter(
    (f): f is File => f instanceof File
  );

  const [couponCode, setCouponCode] = useState("");
  const [isCouponValid, setIsCouponValid] = useState(false);
  const [isCheckingCoupon, setIsCheckingCoupon] = useState(false);
  const [couponError, setCouponError] = useState("");
  const [couponId, setCouponId] = useState < number | null > (null);
  const [appliedCouponId, setAppliedCouponId] = useState < number | null > (null);
  const packageCount = new Set(
    selectedTeeth.map(t => t.orderTypeID)
  ).size;
  const originalPackageCount = new Set(
    selectedTeeth.map(t => t.orderTypeID)
  ).size;


  const handleApply = (coupon: Coupon) => {
    setAppliedCouponId(coupon.couponID);
    setCouponCode(coupon.couponCode);
    setAppliedCoupon(coupon);
    setIsCouponValid(true);

    toast.success("Coupon applied successfully ✅");
  };


  const handleRemoveCoupon = () => {
    setAppliedCoupon(null);
    setAppliedCouponId(null);
    setCouponCode("");
    setIsCouponValid(false);
    setCouponError("");
    setCouponId(null);

    toast.success("Coupon removed successfully");
  };

  const searchedCoupon =
    couponCode.trim() === ""
      ? null
      : coupons.find(
        (coupon) =>
          coupon.couponCode?.trim().toUpperCase() ===
          couponCode.trim().toUpperCase()
      ) ||
      (isCouponValid && couponId
        ? coupons.find(coupon => coupon.couponID === couponId)
        : null);

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const token = sessionStorage.getItem("token") || "";

        const res = await apiAxios.get(
          `${API_BASE}/Coupon/GetAllCouponByDentist`,
          {
            headers: { AuthorizationData: token }
          }
        );

        if (res.data?.isSuccess) {
          setCoupons(res.data.singleData || []);
        }
      } catch (err) {
        console.error("Failed to load coupons", err);
      }
    };

    fetchCoupons();
  }, []);




  const [clinic, setClinic] = useState < {
    clinicID: number;
    clinicName: string;
    address?: string;
  } | null > (null);

  const [priceSummary, setPriceSummary] = useState({
    singleTotal: 0,
    bridgeTotal: 0,
    grandTotal: 0,
  });

  useEffect(() => {
    const savedOrder = localStorage.getItem("orderSummary");
    if (savedOrder) {
      const parsed = JSON.parse(savedOrder);
      setSelectedTeeth(parsed.selectedTeeth || []);
    }
  }, []);

  useEffect(() => {
    if (!orderDraft) return;
    setPatientId(orderDraft.patientId);
  }, [orderDraft]);

  useEffect(() => {
    const storedClinic = sessionStorage.getItem("selectedClinic");

    if (storedClinic) {
      const parsedClinic = JSON.parse(storedClinic);
      setClinic(parsedClinic);
    }

  }, []);


  /* ---------------------- Load order data ---------------------- */
  useEffect(() => {
    const savedOrder = localStorage.getItem("orderSummary");

    //console.log("orderSummary =>", savedOrder);

    if (savedOrder) {
      const parsed = JSON.parse(savedOrder);

      console.log("parsed =>", parsed);
      console.log("parsed.selectedTeeth =>", parsed.selectedTeeth);

      setSelectedTeeth(
        (parsed.selectedTeeth || []).map((t: ToothData) => {
          if (t.duration! < 1440) return { ...t, orderType: t.duration };

          const days = Math.ceil(t.duration! / 1440);

          return {
            ...t,
            orderType: `${days}day`,
          };
        })
      );

      setPriceSummary(
        parsed.priceSummary || {
          singleTotal: 0,
          bridgeTotal: 0,
          grandTotal: 0,
        }
      );
    }
  }, []);



  useEffect(() => {
    if (couponCode.length > 6) {
      validateCoupon(couponCode);
    } else {
      setIsCouponValid(false);
      setCouponError("");
    }
  }, [couponCode]);

  const validateCoupon = async (code: string) => {
    try {
      setIsCheckingCoupon(true);
      setCouponError("");

      const token = sessionStorage.getItem("token") || "";

      const res = await apiAxios.get(
        `${API_BASE}/Coupon/Validate?couponCode=${encodeURIComponent(code)}`,
        {
          headers: { AuthorizationData: token }
        }
      );

      if (res.data?.isSuccess && res.data?.singleData?.length > 0) {
        const coupon = res.data.singleData[0];

        setCouponId(coupon.couponID);
        setIsCouponValid(true);

        // Do NOT clear applied coupon here
        // Only validation is being done
      } else {
        setCouponId(null);
        setIsCouponValid(false);
        setCouponError(res.data?.status || "Invalid coupon code");
      }
    } catch (error) {
      setCouponId(null);
      setIsCouponValid(false);
      setCouponError("Coupon validation failed");
    } finally {
      setIsCheckingCoupon(false);
    }
  };

  const DESIGN_SERVICE_PRICE_PER_TOOTH = 250;

  const getToothPrice = (tooth: ToothData) => {
    return isDesignService
      ? DESIGN_SERVICE_PRICE_PER_TOOTH
      : (tooth.price || 0);
  };
  const handleUpdateDelivery = async (caseID: number) => {
    try {
      console.log("Updating CaseID:", caseID);
      console.log("Selected Delivery:", selectedPopupDelivery[caseID]);
      setIsUpdatingDelivery(true);

      const orderTypeID = selectedPopupDelivery[caseID];

      const selectedType = availableDeliveryTypes.find(
        x => x.orderTypeID === Number(orderTypeID)
      );

      if (!selectedType) return;

      await apiAxios.post("/Dentist/UpdateOrderType", {
        caseID,
        orderTypeID
      });

      // ✅ Find the package this caseID actually belongs to
      const affectedPackage = orderPackages.find(
        pkg => pkg.caseID === caseID
      );

      // ✅ Update the package itself so the screen reflects the new delivery type immediately
      setOrderPackages(prev =>
        prev.map(pkg =>
          pkg.caseID === caseID
            ? {
              ...pkg,
              orderTypeId: selectedType.orderTypeID,
              orderTypeName: selectedType.orderTypeName
            }
            : pkg
        )
      );

      // ✅ Update the underlying teeth so the grouping logic stays in sync too
      if (affectedPackage) {
        const affectedToothNumbers = affectedPackage.teeth.map(t => t.toothNumber);

        setSelectedTeeth(prev =>
          prev.map(t =>
            affectedToothNumbers.includes(t.toothNumber)
              ? { ...t, orderTypeID: selectedType.orderTypeID }
              : t
          )
        );
      }

      setUnavailableOrders(prev => {
        const updated = prev.filter(x => x.caseID !== caseID);

        if (updated.length === 0) {
          setShowDeliveryPopup(false);
        }

        return updated;
      });

      toast.success("Delivery updated successfully");
    } catch (err) {
      console.error(err);
      toast.error("Failed to update delivery");
    } finally {
      setIsUpdatingDelivery(false);
    }
  };

  /* ---------------------- Calculate totals ---------------------- */

  useEffect(() => {
    let singleTotal = 0;
    let bridgeTotal = 0;
    let total = 0;

    // ✅ DESIGN SERVICE => ₹250 per tooth
    if (isDesignService) {
      total = selectedTeeth.length * 250;

      if (appliedCoupon) {
        if (appliedCoupon.percentage > 0) {
          const discount = (total * appliedCoupon.percentage) / 100;
          total = total - discount;
        } else if (appliedCoupon.amount > 0) {
          total = total - appliedCoupon.amount;
        }
      }



      total = Math.max(0, total);

      setPriceSummary({
        singleTotal: total,
        bridgeTotal: 0,
        grandTotal: total,
      });

      return;
    }

    // ✅ FULL SERVICE => old logic
    singleTotal = selectedTeeth
      .filter(t => !t.hasBridge)
      .reduce((sum, t) => sum + (t.price || 0), 0);

    bridgeTotal = selectedTeeth
      .filter(t => t.hasBridge)
      .reduce((sum, t) => sum + (t.price || 0), 0);

    total = singleTotal + bridgeTotal;

    if (appliedCoupon) {
      if (appliedCoupon.percentage > 0) {
        const discount = (total * appliedCoupon.percentage) / 100;
        total = total - discount;
      } else if (appliedCoupon.amount > 0) {
        total = total - appliedCoupon.amount;
      }
    }

    total = Math.max(0, total);

    setPriceSummary({
      singleTotal,
      bridgeTotal,
      grandTotal: total,
    });
  }, [selectedTeeth, appliedCoupon, isDesignService]);
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const navigate = useNavigate();

  const saveDraftCase = async () => {
    try {
      setIsDetailUploaded(true);
      const token = sessionStorage.getItem("token") || "";

      const formData = new FormData();

      const existingDraftId = sessionStorage.getItem("draftId");

      const rawCaseID = sessionStorage.getItem("caseID") || "";
      // ✅ convert "20,21" → [20,21]
      const caseIDs = rawCaseID
        .split(",")
        .map(id => Number(id.trim()))
        .filter(id => !isNaN(id));

      formData.append("DraftId", existingDraftId || "0");
      // formData.append("DraftId", "0"); // new draft
      if (!isDesignService) {
        formData.append("PatientID", patientId!.toString());
      }
      else {
        formData.append("PatientID", '0');
      }


      formData.append("clinicId", clinic!.clinicID.toString());
      formData.append("IsDesignService", isDesignService ? "true" : "false");
      if (isSlotBooking) {
        formData.append("IsSlotBooking", "true");
        formData.append("SlotDate", slotDate);
        formData.append("SlotTime", slotTime);
      }
      formData.append("TaxAmount", taxAmount.toFixed(2));
      formData.append("GrandTotal", finalAmount.toFixed(2));
      formData.append("Note", notes || "");
      const storedFileUrl = sessionStorage.getItem("fileUrl") || "";
      formData.append("FileUrl", storedFileUrl);
      formData.append("IsDraft", "true"); // ⭐ important
      caseIDs.forEach(id => {
        formData.append("CaseIds", id.toString());
      });

      const packages = isDesignService
        ? [{
          orderTypeId: 0,
          teeth: selectedTeeth
        }]
        : orderPackages;

      packages.forEach((pkg, pIndex) => {

        formData.append(
          `Packages[${pIndex}].OrderTypeId`,
          pkg.orderTypeId.toString()
        );

        pkg.teeth.forEach((t, tIndex) => {

          console.log("Sending Tooth =>", t);

          formData.append(
            `Packages[${pIndex}].Teeth[${tIndex}].ToothNumber`,
            String(t.toothNumber)
          );

          formData.append(
            "ClubAllPackages",
            clubAllPackages.toString()
          );

          if (!isDesignService) {

            formData.append(
              `Packages[${pIndex}].Teeth[${tIndex}].MaterialID`,
              String(t.materialId)
            );

            formData.append(
              `Packages[${pIndex}].Teeth[${tIndex}].ShadeID`,
              String(t.shadeId)
            );
          }

          formData.append(
            `Packages[${pIndex}].Teeth[${tIndex}].HasBridge`,
            String(t.hasBridge ?? false)
          );

          if (t.bridgeGroupId != null) {
            formData.append(
              `Packages[${pIndex}].Teeth[${tIndex}].BridgeGroupId`,
              String(t.bridgeGroupId)
            );
          }

        });

      });

      realFiles.forEach(file => {
        formData.append("Files", file);
      });

      if (attachmentFiles?.length > 0) {
        formData.append("NoteFile", attachmentFiles[0]);
      }




      const res = await apiAxios.post(
        `${API_BASE}/Dentist/CreateCase`,
        formData,

        {
          headers: { AuthorizationData: token },
          timeout: 300000
        }
      );
      if (res.data?.caseDetail?.singleData?.caseIDs) {
        const draftId = res.data.caseDetail.singleData.caseIDs;
        sessionStorage.setItem("caseID", draftId);

        const caseIDArray = String(draftId)
          .split(",")
          .map((id: string) => Number(id.trim()))
          .filter((id: number) => !isNaN(id));

        if (isDesignService) {
          setOrderPackages(prev =>
            prev.map(pkg => ({
              ...pkg,
              caseID: caseIDArray[0]
            }))
          );
        } else {
          setOrderPackages(prev =>
            prev.map((pkg, idx) => ({
              ...pkg,
              caseID: caseIDArray[idx]
            }))
          );
        }
      }

    } catch (err) {
      console.error("Draft save failed", err);
    }
    finally {
      setIsDetailUploaded(false);
    }
  };

  useEffect(() => {
    const handleUnload = () => {
      clearOrderSession();
    };

    window.addEventListener("beforeunload", handleUnload);



    return () => {
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, []);


  useEffect(() => {
    const fetchDeliveryTypes = async () => {
      try {
        const token = sessionStorage.getItem("token");
        if (!token) return;

        const res = await apiAxios.get(`${API_BASE}/OrderTypeMaster/GetAll`, {
          headers: { AuthorizationData: token },
        });

        // Make sure we have an array
        const typesArray = Array.isArray(res.data.singleData) ? res.data.singleData : [];
        setDeliveryTypes(typesArray);
        // Default selection
        if (typesArray.length > 0) {
          setSelectedDelivery(typesArray[0]);
        }
      } catch (err) {
        console.error("Failed to load delivery types", err);
        setDeliveryTypes([]); // fallback to empty array
      }
    };
    if (isDesignService)
      return;
    fetchDeliveryTypes();
  }, [isDesignService]);


  const hasSavedDraft = React.useRef(false);



  useEffect(() => {
    if (
      hasSavedDraft.current ||
      !orderPackages.length ||
      !clinic ||
      (!isDesignService && !patientId)
    ) return;
    hasSavedDraft.current = true;
    saveDraftCase();

  }, [orderPackages, patientId, clinic, isDesignService]);

  useEffect(() => {
    if (isDesignService) {

      setOrderPackages([
        {
          orderTypeId: 0,
          orderTypeName: "Design Service",
          teeth: selectedTeeth
        }
      ]);

      return;
    }
    if (!selectedTeeth.length || !deliveryTypes.length) return;

    // 🔹 CLUB ALL INTO ONE PACKAGE
    if (clubAllPackages) {

      const maxDeliveryType = deliveryTypes.reduce((max, curr) => {
        const currTime = curr.turnaroundTimeValue || 0;
        const maxTime = max?.turnaroundTimeValue || 0;
        return currTime > maxTime ? curr : max;
      }, deliveryTypes[0]);

      // setSelectedTeeth(prev =>
      //   prev.map(t => ({
      //     ...t,
      //     orderTypeID: maxDeliveryType.orderTypeID
      //   }))
      // );

      setOrderPackages([
        {
          orderTypeId: maxDeliveryType.orderTypeID,
          orderTypeName: maxDeliveryType.orderTypeName,
          teeth: selectedTeeth.map(t => ({
            ...t,
            orderTypeID: maxDeliveryType.orderTypeID
          }))
        }
      ]);

      return;
    }

    // 🔹 NORMAL MODE
    const grouped: Record<number, ToothData[]> = {};

    selectedTeeth.forEach(t => {
      const id = t.orderTypeID!;
      if (!grouped[id]) grouped[id] = [];
      grouped[id].push(t);
    });

    const packages: OrderPackage[] = Object.entries(grouped).map(
      ([orderTypeId, teeth]) => {
        const matched = deliveryTypes.find(
          d => d.orderTypeID === Number(orderTypeId)
        );

        return {
          orderTypeId: Number(orderTypeId),
          orderTypeName: matched?.orderTypeName,
          teeth
        };
      }
    );

    setOrderPackages(packages);

  }, [clubAllPackages, selectedTeeth, deliveryTypes, isDesignService]);

  useEffect(() => {
    console.log("selectedTeeth =>", selectedTeeth);
  }, [selectedTeeth]);
  const clearOrderSession = () => {
    localStorage.removeItem("orderSummary");

    sessionStorage.removeItem("caseID");
    sessionStorage.removeItem("draftId");
  };

  const handleLogout = async () => {
    try {
      const token = sessionStorage.getItem("token");
      if (token)
        await apiAxios.post(
          `${API_BASE}/Auth/logout`,
          {},
          { headers: { Authorization: `Bearer ${token}` } }
        );
    } catch {
      console.warn("Logout failed or expired");
    } finally {
      sessionStorage.clear();
      navigate(ROUTES.HOME);
    }
  };


  const loadRazorpay = () => {
    return new Promise((resolve) => {
      if ((window as any).Razorpay) {
        resolve(true);
        return;
      }

      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });
  };

  const createRazorpayOrder = async () => {
    const token = sessionStorage.getItem("token") || "";

    const rawCaseID = sessionStorage.getItem("caseID") || "";

    const caseIDs = rawCaseID
      .split(",")
      .map(id => Number(id.trim()))
      .filter(id => !isNaN(id));

    const user = JSON.parse(
      sessionStorage.getItem("user") || "{}"
    );

    const selectedClinic = JSON.parse(
      sessionStorage.getItem("selectedClinic") || "{}"
    );

    const taxes = [];

    if (!isInterState) {
      taxes.push({
        taxType: "CGST",
        taxPercentage: 2.5,
        taxAmount: Number(cgstAmount.toFixed(2))
      });

      taxes.push({
        taxType: "SGST",
        taxPercentage: 2.5,
        taxAmount: Number(sgstAmount.toFixed(2))
      });
    } else {
      taxes.push({
        taxType: "IGST",
        taxPercentage: 5,
        taxAmount: Number(igstAmount.toFixed(2))
      });
    }

    const originalAmount = orderPackages.reduce(
      (packageTotal, pkg) =>
        packageTotal +
        pkg.teeth.reduce(
          (toothTotal, tooth) => toothTotal + getToothPrice(tooth),
          0
        ),
      0
    );


    const res = await apiAxios.post(
      `${API_BASE}/payment/create-order`,
      {
        IsClubbed: clubAllPackages,
        amount: Number(finalAmount.toFixed(2)),
        originalAmount: originalAmount,
        couponPercentage: Number(appliedCoupon?.percentage) || 0,
        couponDiscountAmount: Number(couponDiscount.toFixed(2)),
        email: selectedClinic.emailID || user.email,
        contact: selectedClinic.deliveryContact,
        caseIDs,
        couponID: appliedCouponId || null,
        taxes
      },

      {
        headers: {
          AuthorizationData: token
        }
      }
    );
    if (res.data.deliveryUnavailable) {
      setAvailableDeliveryTypes(
        res.data.availableDeliveryTypes?.length
          ? res.data.availableDeliveryTypes
          : deliveryTypes
      );

      setUnavailableOrders(
        res.data.unavailableOrders || []
      );

      setShowDeliveryPopup(true);

      return null; // instead of throw
    }
    return res.data;
  };



  const paymentCompletedRef = useRef(false);
  const formatCaseIDs = (caseIDs: any) =>
    caseIDs.map((id: any) => `TZ${id}`).join(", ");

  const openRazorpay = async () => {
    // ✅ FREE ORDER (100% coupon)
    if (finalAmount === 0) {
      freePaymentHandler();
      return;
    }

    const loaded = await loadRazorpay();

    if (!loaded) {
      toast.error("Razorpay SDK failed to load");
      return;
    }

    try {
      setIsPlacingOrder(true);

      const order = await createRazorpayOrder();
      if (!order) {
        setIsPlacingOrder(false);
        return;
      }
      const rawCaseID = sessionStorage.getItem("caseID") || "";

      const caseIDs = rawCaseID
        .split(",")
        .map(id => Number(id.trim()))
        .filter(id => !isNaN(id));

      const selectedClinic = JSON.parse(sessionStorage.getItem("selectedClinic") || "{}");
      const options = {
        key: RAZORPAY_KEY,
        amount: order.amount * 100,
        currency: "INR",
        name: "TOOTHZAP PRIVATE LIMITED",
        description: caseIDs.length > 0
          ? `Case IDs: ${formatCaseIDs(caseIDs)}`
          : "ToothZap Payment",
        order_id: order.orderId,

        handler: async function (response: any) {
          paymentCompletedRef.current = true;
          await verifyPayment(response, order.dbPaymentId);
        },

        prefill: {
          name: selectedClinic.clinicName,
          email: selectedClinic.emailID,
          contact: selectedClinic.deliveryContact
        },
        notes: {
          CaseIDs: formatCaseIDs(caseIDs),
          ClinicName: selectedClinic.clinicName,
          ClinicEmail: selectedClinic.emailID
        },

        theme: {
          color: "#0d6efd"
        },

        modal: {
          escape: true,
          backdropclose: false,
          confirm_close: true,
          ondismiss: async function () {

            if (paymentCompletedRef.current) return;

            await saveFailedPayment({
              paymentDbId: order.dbPaymentId,
              errorDescription: "Payment cancelled by user"
            });

            toast.info("Payment cancelled");

            setIsPlacingOrder(false);
          }
        }
      };

      const rzp = new (window as any).Razorpay(options);
      // ✅ Register failure event FIRST
      rzp.on("payment.failed", async function (response: any) {

        // ✅ CLOSE POPUP
        rzp.close();

        await saveFailedPayment({
          paymentDbId: order.dbPaymentId,
          razorpayOrderId: response.error.metadata.order_id,
          razorpayPaymentId: response.error.metadata.payment_id,
          errorCode: response.error.code,
          errorDescription: response.error.description,
          errorSource: response.error.source,
          errorStep: response.error.step,
          errorReason: response.error.reason
        });

        toast.error(response.error.description || "Payment Failed");

        setIsPlacingOrder(false);
      });
      rzp.open();

    } catch (err: any) {
      console.error(err);

      const responseData = err?.response?.data;

      console.log("responseData =>", responseData);
      console.log("unavailableOrders =>", responseData?.unavailableOrders);

      if (responseData?.unavailableOrders?.length > 0) {

        setAvailableDeliveryTypes(
          responseData.availableDeliveryTypes?.length
            ? responseData.availableDeliveryTypes
            : deliveryTypes
        );

        setUnavailableOrders(responseData.unavailableOrders);

        setShowDeliveryPopup(true);

        setIsPlacingOrder(false);
        return;
      }

      toast.error(
        responseData?.message ||
        "Payment initialization failed"
      );

      setIsPlacingOrder(false);
    }


  };

  const freePaymentHandler = async () => {
    try {

      setIsPlacingOrder(true);

      const token = sessionStorage.getItem("token") || "";

      const rawCaseID =
        sessionStorage.getItem("caseID") || "";

      const caseIDs = rawCaseID
        .split(",")
        .map(id => Number(id.trim()))
        .filter(id => !isNaN(id));

      // ✅ DIRECT VERIFY API
      const res = await apiAxios.post(
        `${API_BASE}/payment/free-payment`,
        {
          caseIDs,
          couponId: appliedCouponId,
          OriginalAmount: originalAmount
        },
        {
          headers: {
            AuthorizationData: token
          }
        }
      );

      if (res.data?.success) {
        toast.success(
          "Order placed successfully 🎉"
        );
        // ✅ CLEAR STORAGE
        localStorage.removeItem("orderSummary");

        sessionStorage.removeItem("caseID");
        sessionStorage.removeItem("draftId");
        sessionStorage.removeItem("fileUrl");
        sessionStorage.removeItem("caseNotes");
        setTimeout(() => {
          if (onHandleBack) {
            onHandleBack();
          }
          else {
            navigate(
              ROUTES.DENTIST.DENTIST_DASHBOARD
            );
          }
        }, 1500);
      }
      else {
        toast.error(
          res.data?.message ||
          "Free payment failed"
        );
      }

    } catch (err: any) {



      console.error(err);

      toast.error(
        err?.response?.data?.message ||
        "Free payment failed"
      );

    } finally {

      setIsPlacingOrder(false);
    }

    return;
  };
  const saveFailedPayment = async (payload: any) => {
    try {

      const token = sessionStorage.getItem("token") || "";

      await apiAxios.post(
        `${API_BASE}/payment/payment-failed`,
        payload,
        {
          headers: { AuthorizationData: token }
        }
      );

    } catch (err) {
      console.error("Failed payment save error", err);
    }
  };
  const isVerifyingRef = useRef(false);

  const verifyPayment = async (
    response: any,
    dbPaymentId: number
  ) => {

    // ✅ Prevent duplicate verify calls
    if (isVerifyingRef.current) {
      return;
    }

    isVerifyingRef.current = true;

    try {

      setIsPlacingOrder(true);

      const token =
        sessionStorage.getItem("token") || "";

      const rawCaseID =
        sessionStorage.getItem("caseID") || "";

      const caseIDs = rawCaseID
        .split(",")
        .map(id => Number(id.trim()))
        .filter(id => !isNaN(id));

      const res = await apiAxios.post(
        `${API_BASE}/payment/verify`,
        {
          paymentDbId: dbPaymentId,
          razorpayOrderId: response.razorpay_order_id,
          razorpayPaymentId: response.razorpay_payment_id,
          razorpaySignature: response.razorpay_signature,
          caseIDs
        },
        {
          headers: {
            AuthorizationData: token
          }
        }
      );


      // ✅ SUCCESS RESPONSE
      if (res.data) {

        const message =
          res.data?.message || "Payment Successful";

        toast.success(message);

        // ✅ Clear local storage
        localStorage.removeItem("orderSummary");

        // ✅ Remove temp session values
        sessionStorage.removeItem("caseID");
        sessionStorage.removeItem("draftId");
        sessionStorage.removeItem("fileUrl");
        sessionStorage.removeItem("caseNotes");
        setTimeout(() => {

          if (onHandleBack) {
            onHandleBack();
          }
          else {
            navigate(
              ROUTES.DENTIST.DENTIST_DASHBOARD
            );
          }

        }, 1500);
      }
      else {

        throw new Error(
          res.data?.message ||
          "Payment verification failed"
        );
      }
    }
    catch (err: any) {

      console.error(
        "VERIFY PAYMENT ERROR =>",
        err
      );

      const errorMessage =
        err?.response?.data?.message ||
        err?.message ||
        "Payment verification failed";

      toast.error(errorMessage);

      // ✅ Save failed payment log
      await saveFailedPayment({
        paymentDbId: dbPaymentId,
        errorDescription: errorMessage
      });


    }
    finally {

      setIsPlacingOrder(false);

      isVerifyingRef.current = false;
    }
  };



  const CGST_RATE = 2.5;
  const SGST_RATE = 2.5;
  const IGST_RATE = 5;

  const clinicAddress = clinic?.address?.toLowerCase() || "";

  // Delhi = Intra-state
  const isDelhiClinic =
    clinicAddress.includes("delhi") ||
    clinicAddress.includes("new delhi");

  // Non-Delhi = Inter-state
  const isInterState = !isDelhiClinic;
  const originalSubTotal = orderPackages.reduce(
    (packageTotal, pkg) =>
      packageTotal +
      pkg.teeth.reduce(
        (toothTotal, tooth) => toothTotal + getToothPrice(tooth),
        0
      ),
    0
  );

  const couponDiscount = appliedCoupon
    ? Number(appliedCoupon.percentage) > 0
      ? (originalSubTotal * Number(appliedCoupon.percentage)) / 100
      : Number(appliedCoupon.amount) > 0
        ? Number(appliedCoupon.amount)
        : 0
    : 0;

  const subTotal = Math.max(0, originalSubTotal - couponDiscount);

  const cgstAmount = !isInterState
    ? (subTotal * CGST_RATE) / 100
    : 0;

  const sgstAmount = !isInterState
    ? (subTotal * SGST_RATE) / 100
    : 0;

  const igstAmount = isInterState
    ? (subTotal * IGST_RATE) / 100
    : 0;

  const taxAmount =
    cgstAmount +
    sgstAmount +
    igstAmount;

  const finalAmount =
    subTotal + taxAmount;

  const originalAmount = orderPackages.reduce(
    (packageTotal, pkg) =>
      packageTotal +
      pkg.teeth.reduce(
        (toothTotal, tooth) => toothTotal + getToothPrice(tooth),
        0
      ),
    0
  );

  return (
    <div className="place-order-wrapper">
      <div className="row">
        {/* <h5 className="order-summary mb-3">Order Summary</h5> */}
        <div className="col-md-12 col-12 col-sm-12 col-lg-8 mx-auto mt-4">

          <div className="container px-0 py-4 conten-container-section">
            <div className="row order-summary-marginleft-right">
              <div className="col-md-12">
                <h4 className="order-summary">Order Summary</h4>
                {isSlotBooking && (
                  <div className="order-package-box2 mb-3">
                    <div className="package-title">Scheduled Slot</div>
                    <p className="text-muted mb-0">
                      <strong>{formatSlotDate(slotDate)}</strong> at{" "}
                      <strong>{formatSlotTime(slotTime)}</strong>
                    </p>
                  </div>
                )}
                {!isDesignService && (
                  <>
                    <div className="package-header-address">
                      <div className="package-title">Address</div>
                    </div>
                    <div className="order-package-box2 mb-4">
                      <p className="text-muted mb-0">
                        {clinic ? (
                          <>
                            <strong>{clinic.clinicName}</strong><br />
                            {clinic.address || "Address not available"}{" "}
                          </>
                        ) : (
                          "No Clinic Selected"
                        )}
                      </p>
                    </div>
                  </>
                )}

                {/* ===================== SINGLE TEETH PACKAGE ===================== */}



                {/* ===================== BRIDGE PACKAGE ===================== */}
                {/* {orderPackages.length > 1 && (
                  <div className="mb-3 d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      id="clubDeliveries"
                      checked={clubAllPackages}
                      onChange={(e) => setClubAllPackages(e.target.checked)}
                    />
                    <label htmlFor="clubDeliveries" className="mb-0 club-all-delivers">
                      Club all deliveries into one package (maximum delivery time)
                    </label>
                  </div>
                )} */}
                {!isDesignService && originalPackageCount > 1 && (
                  <div className="mb-3 d-flex align-items-center gap-2">
                    <input
                      type="checkbox"
                      id="clubDeliveries"
                      checked={clubAllPackages}
                      onChange={(e) => setClubAllPackages(e.target.checked)}
                    />
                    <label htmlFor="clubDeliveries" className="mb-0 club-all-delivers">
                      Club all deliveries into one package (maximum delivery time)
                    </label>
                  </div>
                )}

                {/* <div className="mb-3 d-flex align-items-center gap-2">
                  <input
                    type="checkbox"
                    id="clubDeliveries"
                    checked={clubAllPackages}
                    onChange={(e) => setClubAllPackages(e.target.checked)}
                  />
                  <label htmlFor="clubDeliveries" className="mb-0 club-all-delivers">
                    Club all deliveries into one package (maximum delivery time)
                  </label>
                </div> */}


                {/* ===================== ORDER PACKAGES (DYNAMIC) ===================== */}
                {orderPackages.map((pkg, index) => (
                  <div className="mb-4" key={pkg.orderTypeId}>

                    <div className="package-header">
                      <div className="package-title">
                        Package {index + 1}
                        {!isDesignService && ` - ${pkg.orderTypeName}`}
                      </div>
                      {!isDesignService && (
                        <Dropdown>
                          <Dropdown.Toggle className="btn btn-ninety-minute-delivery delivery-badge" disabled>
                            {pkg.orderTypeName || "Select Delivery"}
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            {deliveryTypes.map(option => (
                              <Dropdown.Item
                                key={option.orderTypeID}
                                onClick={() => {
                                  // 🔁 Update package
                                  setOrderPackages(prev =>
                                    prev.map(p =>
                                      p.orderTypeId === pkg.orderTypeId
                                        ? {
                                          ...p,
                                          orderTypeId: option.orderTypeID,
                                          orderTypeName: option.orderTypeName
                                        }
                                        : p
                                    )
                                  );

                                  // 🔁 Update teeth orderTypeID
                                  setSelectedTeeth(prev =>
                                    prev.map(t =>
                                      t.orderTypeID === pkg.orderTypeId
                                        ? { ...t, orderTypeID: option.orderTypeID }
                                        : t
                                    )
                                  );
                                }}
                              >
                                {option.orderTypeName}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>

                      )}
                    </div>

                    <div className="order-package-box">
                      <table className="order-item-table">
                        <thead>
                          <tr>
                            <th>Item</th>
                            <th>Qty</th>
                            <th>Unit Price</th>
                            <th>Total</th>
                          </tr>
                        </thead>

                        <tbody>
                          {pkg.teeth.map(t => {
                            const rowPrice = getToothPrice(t);

                            return (
                              <tr key={t.toothNumber}>
                                <td>
                                  {isDesignService
                                    ? `Tooth ${t.toothNumber}`
                                    : `${t.materialName} (Tooth ${t.toothNumber})`}
                                </td>
                                <td>1</td>
                                <td>₹ {rowPrice}</td>
                                <td>₹ {rowPrice}</td>
                              </tr>
                            );
                          })}

                          <tr className="package-total-row">
                            <td colSpan={3}>Total</td>
                            <td>
                              ₹ {pkg.teeth.reduce((s, t) => s + getToothPrice(t), 0)}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                  </div>
                ))}

                <div className="coupon py-2">

                  <div className="package-title pb-3">Have a Coupon?</div>

                  <input
                    type="text"
                    className="form-control mb-3"
                    placeholder="Enter coupon code"
                    value={couponCode}
                    disabled={appliedCouponId !== null}
                    onChange={(e) => setCouponCode(e.target.value.toUpperCase())}

                  />

                  <div className="small-coupon-code-section">
                    {searchedCoupon && (
                      <div className="small-coupon-code mb-3">
                        <div className="offer-code-content">

                          <div className="icon-part-of-coupon">
                            <i className="bi bi-tag-fill coupon-small-icon"></i>

                            <div className="coupon-codetext-left">
                              <div className="rupees-text">
                                {Number(searchedCoupon.percentage) > 0
                                  ? `${searchedCoupon.percentage}% Off`
                                  : `₹${searchedCoupon.amount} Off`}
                              </div>

                              <div className="coupon-code">
                                {searchedCoupon.couponCode}
                              </div>
                            </div>
                          </div>

                          <div className="coupon-codetext-right">
                            {appliedCouponId === searchedCoupon.couponID ? (
                              <button
                                type="button"
                                className="apply-text applied"
                                onClick={handleRemoveCoupon}
                              >
                                Remove
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="apply-text"
                                onClick={() => handleApply(searchedCoupon)}
                                disabled={!isCouponValid}
                              >
                                Apply
                              </button>
                            )}
                          </div>

                        </div>
                      </div>
                    )}
                  </div>

                  {isCheckingCoupon && (
                    <small className="text-info">Checking coupon...</small>
                  )}

                  {couponError && (
                    <small className="text-danger">{couponError}</small>
                  )}

                  {isCouponValid && (
                    <small className="text-success">Coupon applied 🎉</small>
                  )}

                </div>

                <div className="row">

                  <div className="col-md-7">

                  </div>
                  <div className="col-md-5">
                    <div className="wallet-section">

                      <div className="summary-row-taxes">
                        Sub Total :
                        <span className="float-end">
                          ₹ {subTotal.toFixed(2)}
                        </span>
                      </div>

                      {showDeliveryPopup && (
                        <div className="global-loader-overlay">

                          <div className="loader-box delivery-popup">

                            <p className="mb-3">
                              ⚠️ 90-Minute Delivery Temporarily Unavailable
                              Due to a surge in cases, our 90-minute delivery service is temporarily unavailable. Please select different delivery type.
                            </p>

                            <div className="table-responsive">
                              <table className="table delivery-popup-table mb-0">
                                <thead>
                                  <tr>
                                    <th>Order ID</th>
                                    <th>Select Delivery</th>
                                    <th className="text-center">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {unavailableOrders.map((order) => (
                                    <tr key={order.caseID}>

                                      <td>
                                        <strong>
                                          {order.orderID}
                                        </strong>
                                      </td>

                                      <td>
                                        <select
                                          className="form-select"
                                          onChange={(e) => {

                                            setSelectedPopupDelivery(prev => ({
                                              ...prev,
                                              [order.caseID]: Number(e.target.value)
                                            }));

                                          }}
                                        >

                                          <option value="">
                                            Select Delivery
                                          </option>

                                          {(availableDeliveryTypes.length > 0
                                            ? availableDeliveryTypes
                                            : deliveryTypes
                                          )
                                            .filter(
                                              type =>
                                                type.orderTypeName.toLowerCase() !== "express" &&
                                                type.orderTypeName.toLowerCase() !== "design service"
                                            )
                                            .map(type => (
                                              <option
                                                key={type.orderTypeID}
                                                value={type.orderTypeID}
                                              >
                                                {type.orderTypeName}
                                              </option>
                                            ))}

                                        </select>
                                      </td>

                                      <td className="text-center">
                                        <button
                                          className="btn btn-primary btn-sm"
                                          disabled={!selectedPopupDelivery[order.caseID]}
                                          onClick={() => handleUpdateDelivery(order.caseID)}
                                        >
                                          Update
                                        </button>
                                      </td>

                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>

                            <div className="d-flex justify-content-center mt-3">
                              <button
                                className="btn btn-secondary custom-sec-height"
                                onClick={() => {
                                  setShowDeliveryPopup(false);
                                }}
                              >
                                Cancel
                              </button>
                            </div>

                          </div>

                        </div>
                      )}

                      {!isInterState ? (
                        <>
                          <div className="summary-row-taxes">
                            CGST (2.5%)
                            <span className="float-end">
                              ₹ {cgstAmount.toFixed(2)}
                            </span>
                          </div>

                          <div className="summary-row-taxes">
                            SGST (2.5%)
                            <span className="float-end">
                              ₹ {sgstAmount.toFixed(2)}
                            </span>
                          </div>
                        </>
                      ) : (
                        <div className="summary-row-taxes">
                          IGST (5%)
                          <span className="float-end">
                            ₹ {igstAmount.toFixed(2)}
                          </span>
                        </div>
                      )}

                      <hr />

                      <div className="grand-total">
                        Grand Total :
                        <span className="amount">
                          ₹ {finalAmount.toFixed(2)}
                        </span>
                      </div>

                    </div>
                  </div>
                </div>


                {/* PAY BUTTON */}
                <div className="pay-btndiv">

                  <button
                    className="pay-btn mt-4"
                    onClick={openRazorpay}
                    disabled={isPlacingOrder}
                  >
                    {isPlacingOrder
                      ? "Processing..."
                      : `Pay & Place Order (₹ ${finalAmount.toFixed(2)})`}
                  </button>
                </div>
              </div>
            </div></div>
        </div>
      </div>

      {isPlacingOrder && (
        <div className="global-loader-overlay">
          <div className="loader-box">

            <div className="circle-loader">
              <span className="circle-text">Processing</span>
            </div>

            <p className="mt-3">Placing your order...</p>

          </div>
        </div>
      )}
      {isDetailUploaded && (
        <div className="global-loader-overlay">
          <div className="loader-box">

            <div className="circle-loader">
              <span className="circle-text">Processing</span>
            </div>

            <p className="mt-3">Uploading order details...</p>

          </div>
        </div>
      )}
    </div>
  );

};

export default PlaceOrder;


